import api from '../components/dashboard/utils/api';

export const SET_EMERGENCY_PERSONNEL = 'SET_EMERGENCY_PERSONNEL';
export const SET_EMERGENCY_DETAILS = 'SET_EMERGENCY_DETAILS';
export const SET_IS_LOADING = 'SET_IS_LOADING';

export const setEmergencyPersonnel = emergencyPersonnel => ({
  type: SET_EMERGENCY_PERSONNEL,
  emergencyPersonnel,
});

export const setEmergencyDetails = emergencyDetails => ({
  type: SET_EMERGENCY_DETAILS,
  emergencyDetails,
});

export const setIsLoading = isLoading => ({
  type: SET_IS_LOADING,
  isLoading,
});

export const fetchEmergencyPersonnel = officeId => dispatch => {
  new Promise((resolve, reject) => {
    dispatch(setIsLoading(true));
    api
      .get(`${window.__env.apiUrl}/whitelabel/emergencies/personnel/${officeId}`)
      .then(({ data }) => {
        dispatch(setEmergencyPersonnel(data));
        resolve();
      })
      .catch(() => {
        reject();
        console.log('err on fetching emergency personnel');
      })
      .finally(() => {
        dispatch(setIsLoading(false));
      });
  });
};

export const fetchEmergencyDetails = officeId => dispatch => {
  api
    .get(`${window.__env.apiUrl}/whitelabel/emergencies/details/${officeId}`)
    .then(({ data = {} }) => {
      dispatch(setEmergencyDetails(data));
    })
    .catch(() => {
      console.log('err on fetching emergency details');
    });
};
